// extracted by mini-css-extract-plugin
export default {"trialBannerWrapper":"improvement-trial-banner_trialBannerWrapper__rpT1g"};